import { createAsyncThunk } from "@reduxjs/toolkit";
import {axios} from '../../common'

const AUTHENTICATION_LOGIN = "authentication/login";
const AUTHENTICATION_CHANGE_PASSWORD = "authentication/changePassword";
const AUTHENTICATION_FORGOT_PASSWORD = "authentication/forgotPassword";

export const login = createAsyncThunk(
  AUTHENTICATION_LOGIN,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("/login", payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const changePassword = createAsyncThunk(
  AUTHENTICATION_CHANGE_PASSWORD,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("/change_password", payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const forgotPassword = createAsyncThunk(
  AUTHENTICATION_FORGOT_PASSWORD,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("/forgot_password", payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
